import { FilterDataContext } from 'providers/FilterData'
import { useContext } from 'react'

const SlotAutoFilterAwareWrapper = (props) => {
  const { items, policyId, renderItem } = props
  const filterDataContext = useContext(FilterDataContext)
  const slotPolicyId = policyId.length > 0 ? policyId[0].replace('contentid/', '') : ''
  const slotData = filterDataContext.collections[slotPolicyId]

  const slotItemsFromProvider = slotData?.data || []
  const itemsToRender = [...items, ...slotItemsFromProvider]

  return (
    <>
      {itemsToRender.map((i, key) => renderItem({ item: i, position: key }))}
    </>
  )
}

export default SlotAutoFilterAwareWrapper
